/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { safeAsyncThrow } from './safe-async-throw';

export const flatMapByKeyList = <T>(
  map: Map<string, T>,
  arr: string[],
): T[] => {
  const res: T[] = [];
  for (const key of arr) {
    const val = map.get(key);
    if (!val) {
      safeAsyncThrow(`[flatMapByKeyList] cannot find ${key} in map`);
      continue;
    }
    res.push(val);
  }
  return res;
};
